export default __webpack_public_path__ + "static/media/Immagine_10.3dd92921.jpg";